module.exports = __webpack_public_path__ + "static/img/map.7c861fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/callMe/map.png
// module id = XZFR
// module chunks = 1